<template>
  <div id="profit-chart"></div>
</template>

<script>
  import d3 from 'd3'
  import c3 from 'c3'

  export default {
    name: 'month-yield-chart',
    props: {
      value: {
        type: Object,
        default: function () {
          return {}
        }
      }
    },
    data: function () {
      return {
      }
    },
    computed: {
      profitColumns () {
        const data = this.value.break_even
        const columns = [
          ['x'],
          ['사업주 수익(누적)'].concat(data)
        ]

        for (let i in data) {
          columns[0].push(i)
        }

        return columns
      }
    },
    methods: {
      init: function () {
        const data = this.value
        const stepList = [
          {value: 0, text: '설치시점'},
          {value: data.zero_point, text: '투자비 회수 시점'},
          {value: data.break_even.length - 1, text: 'REC계약 종료 시점'}
        ]

        // 수익그래프
        let chart = {
          bindto: '#profit-chart',
          data: {
            x: 'x',
            columns: this.profitColumns
          },
          axis: {
            x: {
              type: 'category',
              label: {
                text: '(년)'
              },
              tick: {
                culling: {
                  max: parseInt(this.value.break_even.length / 2) + 1
                },
                fit: true,
                centered: true,
                multiline: false
              }
            },
            y: {
              label: {
                text: '(백만원)',
                position: 'inner-top'
              }
            }
          },
          point: {
            r: 3
          },
          grid: {
            x: {
              lines: stepList
            },
            y: {
              show: true
            }
          },
          color: {
            pattern: ['#c5d3e6']
          },
          tooltip: {
            format: {
              title: function (value) {
                return value + '년'
              },
              value: function (value) {
                return value.toFixed(2)
              }
            }
          },
          onresized: _.debounce(() => {
            this.customChart()
          }, 300)
        }

        // 차트 초기화
        c3.generate(chart)

        this.$nextTick(() => {
          this.customChart()
        })
      },
      customChart: function () {
        /**
         * 차트 레이아웃을 수정하는 함수입니다.
         */

        // x, y 축에 이격거리를 둔다.
        d3.selectAll('#profit-chart .c3-axis-y').attr('transform', 'translate(-15, 0)')

        // x 축을 y 축 0 값에 둔다.
        let yaxisValue = d3.selectAll('#profit-chart .c3-axis-y g')
        let zeroAxisy

        for (let i = 0; i < yaxisValue[0].length; i++) {
          if (yaxisValue[0][i].__data__ === 0) {
            zeroAxisy = yaxisValue[0][i].attributes.transform.value
          }
        }

        d3.selectAll('#profit-chart .c3-axis-x').attr('transform', zeroAxisy)
      }
    },
    created: function () {
    },
    mounted: function () {
      this.init()
    }
  }
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/chart/ProfitChart.vue